<template>
    <div>
 
            <!-- blog-details-area -->
            <section class="blog__details-area">
                <div class="container">
                    <div class="blog__inner-wrap">
                        <div class="row">
                            <div class="col-70">
                                <div class="blog__details-wrap">
                                    <!-- <div class="blog__details-thumb">
                                        <img src="assets/img/blog/blog_details01.jpg" alt="Apexa" />
                                    </div> -->
                                    
                                    <div class="blog__details-content">
                                        <h2 class="title">{{ $route.name }}</h2>
                                    
                                        <p v-for="(item, index) in list_tentang" :key="index" v-html="item.uraian"></p>

                                
                                        
                                    </div>
                                    
 
                                </div>
                            </div>

                            <sidecontentnews></sidecontentnews>

                            
                        </div>
                    </div>
                </div>
            </section>        
    </div>
</template>

<script>
export default {
    data() {
        return {
            list_tentang:[],
        }
    },
    methods: {
    fetchTentang() {
      // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.BASE_URL + 'api/v1/publish_bpkad_tentang/view', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_tentang = res_data  
            // console.log(this.list_tentang);
            
        });     
    },
    },
    mounted() {
        this.fetchTentang()
    },
}
</script>